<div id="layout" class="theme-cyan">
  <app-event-leftmenu></app-event-leftmenu>
  <!-- Main Body: Content -->
  <div class="main px-xl-5 px-lg-4 px-3">

    <!-- Body: -->
    <div class="main-body">

      <!-- Body: Header -->
      <div class="body-header border-bottom py-xl-3 py-2">
        <div class="container">

          <div class="row align-items-center">

            <!-- page title -->
            <div class="col-5 col-xl-4">
              <div class="media">
                <div class="media-body overflow-hidden">
                  <div class="d-flex align-items-center justify-content-between mb-1">
                    <h5 class="text-truncate mb-0 me-auto">My Active Events</h5>
                  </div>
                  <small class="text-truncate text-muted">(last update 1hr ago)</small>
                </div>
              </div>
            </div>

            <!-- page action  -->
            <div class="col-7 col-xl-8 text-end">
              <ul class="nav justify-content-end d-inline-flex">
                <li class="nav-item list-inline-item d-none d-md-block me-2">
                  <a href="javascript:void(0)" class="nav-link text-muted px-3" (click)="isCollapsed = !isCollapsed"
                    [attr.aria-expanded]="!isCollapsed" aria-controls="collapseBasic" title="Search this chat">
                    <i class="zmdi zmdi-search zmdi-hc-lg"></i>
                  </a>
                </li>
              </ul>
            </div>

          </div>

        </div>
      </div>

      <!-- Body: Search -->
      <div class="collapse" id="collapseBasic" [collapse]="isCollapsed" [isAnimated]="true">
        <div class="container-fluid py-2">

          <div class="row">
            <div class="input-group">
              <input type="text" class="form-control" placeholder="Search...">
              <div class="input-group-append">
                <span class="input-group-text text-muted"><small>0 / 0</small></span>
              </div>
              <div class="input-group-append dropdown" dropdown placement="bottom right">
                <button type="button" class="btn btn-secondary">Search</button>


                <button id="button-basic" dropdownToggle type="button" aria-controls="dropdown-basic"
                  class="btn btn-secondary dropdown-toggle dropdown-toggle-split ml-1">
                  <span class="sr-only">Toggle Dropdown</span>
                </button>
                <div id="dropdown-basic" *dropdownMenu class="dropdown-menu dropdown-menu-right" role="menu"
                  aria-labelledby="button-basic">
                  <a href="javascript:void(0);" class="dropdown-item">Action</a>
                  <a href="javascript:void(0);" class="dropdown-item">Another action</a>
                  <a href="javascript:void(0);" class="dropdown-item">Something else here</a>
                  <div role="separator" class="dropdown-divider"></div>
                  <a class="dropdown-item" href="javascript:void(0)">Separated link</a>
                </div>

              </div>
            </div>
          </div>

        </div>
      </div>

      <!-- Page Default -->
      <div class="body-page d-flex py-xl-3 py-2">
        <div class="container">

          <div class="row justify-content-between">
            <div class="col-xl-9 col-lg-8 col-md-12">
              <div class="row row-deck">
                <div class="col-xl-6 col-lg-12">
                  <div class="card mb-4">
                    <img src="../assets/images/gallery/2.jpg" class="card-img-top" alt="...">
                    <div class="card-body">
                      <span class="small text-muted">London</span>
                      <h6 class="card-title">National Mentoring Month 2021</h6>
                      <nav class="d-flex text-muted">
                        <a href="javascript:void(0)" class="icon me-3"><i class="me-1 zmdi zmdi-favorite"></i>215</a>
                        <a href="javascript:void(0)" class="icon me-3"><i class="me-1 zmdi zmdi-comment"></i>105</a>
                        <a href="javascript:void(0)" class="text-muted ms-auto"><i
                            class="me-1 zmdi zmdi-chart-donut"></i>Insights</a>
                      </nav>
                    </div>
                    <ul class="list-group custom list-group-flush">
                      <li class="list-group-item">
                        <div class="row">
                          <div class="col-auto">
                            <div class="text-muted small">Date</div>
                            <span>15 March 2021</span>
                          </div>
                          <div class="col-auto">
                            <div class="text-muted small">Tickets</div>
                            <span>Avilable 17, 33</span>
                          </div>
                        </div>
                      </li>
                      <li class="list-group-item d-flex justify-content-between">
                        <div class="avatar-list avatar-list-stacked">
                          <span>Sponsor by:</span>
                          <img class="avatar xs rounded" src="../assets/images/xs/avatar2.jpg" data-bs-toggle="tooltip"
                            data-placement="top" title="" data-original-title="Sean">
                          <img class="avatar xs rounded ml-1" src="../assets/images/xs/avatar4.jpg"
                            data-bs-toggle="tooltip" data-placement="top" title="" data-original-title="Martin">
                          <img class="avatar xs rounded ml-1" src="../assets/images/xs/avatar10.jpg"
                            data-bs-toggle="tooltip" data-placement="top" title="" data-original-title="Terry">
                        </div>
                        <div class="text-danger">
                          <strong>$250</strong>
                        </div>
                      </li>
                    </ul>
                    <div class="card-body">
                      <div class="d-flex align-items-center">
                        <img src="../assets/images/xs/avatar2.jpg" data-bs-toggle="tooltip" title="" alt="Avatar"
                          class="rounded-circle avatar" data-original-title="Avatar Name">
                        <div class="ms-3 flex-grow-1">
                          <a href="javascript:void(0)" title="">By Kevin Gill</a>
                          <p class="mb-0">15 min ago</p>
                        </div>
                        <div class="dropdown" dropdown placement="bottom right">
                          <a href="javascript:void(0)" class="btn btn-link btn-sm dropdown-toggle" id="button-alignment"
                            dropdownToggle type="button" aria-controls="dropdown-alignment">
                            <i class="zmdi zmdi-more-vert zmdi-hc-lg"></i>
                          </a>
                          <div id="dropdown-alignment" *dropdownMenu class="dropdown-menu dropdown-menu-right"
                            role="menu" aria-labelledby="button-alignment">
                            <a href="javascript:void(0)" class="dropdown-item">Action</a>
                            <a href="javascript:void(0)" class="dropdown-item">Another action</a>
                            <a href="javascript:void(0)" class="dropdown-item">Something else here</a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-xl-6 col-lg-12">
                  <div class="card mb-4">
                    <img src="../assets/images/gallery/3.jpg" class="card-img-top" alt="...">
                    <div class="card-body">
                      <span class="small text-muted">Ottawa</span>
                      <h6 class="card-title">World Braille Day 2021</h6>
                      <nav class="d-flex text-muted">
                        <a href="javascript:void(0)" class="icon me-3"><i class="me-1 zmdi zmdi-favorite"></i>128</a>
                        <a href="javascript:void(0)" class="icon me-3"><i class="me-1 zmdi zmdi-comment"></i>99</a>
                        <a href="javascript:void(0)" class="text-muted ms-auto"><i
                            class="me-1 zmdi zmdi-chart-donut"></i>Insights</a>
                      </nav>
                    </div>
                    <ul class="list-group custom list-group-flush">
                      <li class="list-group-item">
                        <div class="row">
                          <div class="col-auto">
                            <div class="text-muted small">Date</div>
                            <span>13 Feb 2021</span>
                          </div>
                          <div class="col-auto">
                            <div class="text-muted small">Tickets</div>
                            <span>Avilable 5, 21</span>
                          </div>
                        </div>
                      </li>
                      <li class="list-group-item d-flex justify-content-between">
                        <div class="avatar-list avatar-list-stacked">
                          <span>Sponsor by:</span>
                          <img class="avatar xs rounded" src="../assets/images/xs/avatar6.jpg" data-bs-toggle="tooltip"
                            data-placement="top" title="" data-original-title="Sean">
                          <img class="avatar xs rounded ml-1" src="../assets/images/xs/avatar9.jpg"
                            data-bs-toggle="tooltip" data-placement="top" title="" data-original-title="Martin">
                          <img class="avatar xs rounded ml-1" src="../assets/images/xs/avatar1.jpg"
                            data-bs-toggle="tooltip" data-placement="top" title="" data-original-title="Michelle">
                        </div>
                        <div class="text-danger">
                          <strong>$99</strong>
                        </div>
                      </li>
                    </ul>
                    <div class="card-body">
                      <div class="d-flex align-items-center">
                        <img src="../assets/images/xs/avatar5.jpg" data-bs-toggle="tooltip" title="" alt="Avatar"
                          class="rounded-circle avatar" data-original-title="Avatar Name">
                        <div class="ms-3 flex-grow-1">
                          <a href="javascript:void(0)" title="">By Jason Porter</a>
                          <p class="mb-0">22 Dec 2020</p>
                        </div>
                        <div class="dropdown" dropdown placement="bottom right">
                          <a href="javascript:void(0)" class="btn btn-link btn-sm dropdown-toggle" id="button-alignment"
                            dropdownToggle type="button" aria-controls="dropdown-alignment">
                            <i class="zmdi zmdi-more-vert zmdi-hc-lg"></i>
                          </a>
                          <div id="dropdown-alignment" *dropdownMenu class="dropdown-menu dropdown-menu-right"
                            role="menu" aria-labelledby="button-alignment">
                            <a href="javascript:void(0)" class="dropdown-item">Action</a>
                            <a href="javascript:void(0)" class="dropdown-item">Another action</a>
                            <a href="javascript:void(0)" class="dropdown-item">Something else here</a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-xl-6 col-lg-12">
                  <div class="card mb-4">
                    <img src="../assets/images/gallery/4.jpg" class="card-img-top" alt="...">
                    <div class="card-body">
                      <span class="small text-muted">NewYork</span>
                      <h6 class="card-title">Byron Bay Bluesfest</h6>
                      <nav class="d-flex text-muted">
                        <a href="javascript:void(0)" class="icon me-3"><i class="me-1 zmdi zmdi-favorite"></i>458</a>
                        <a href="javascript:void(0)" class="icon me-3"><i class="me-1 zmdi zmdi-comment"></i>85</a>
                        <a href="javascript:void(0)" class="text-muted ms-auto"><i
                            class="me-1 zmdi zmdi-chart-donut"></i>Insights</a>
                      </nav>
                    </div>
                    <ul class="list-group custom list-group-flush">
                      <li class="list-group-item">
                        <div class="row">
                          <div class="col-auto">
                            <div class="text-muted small">Date</div>
                            <span>22 Jan 2021</span>
                          </div>
                          <div class="col-auto">
                            <div class="text-muted small">Tickets</div>
                            <span>Avilable 5, 48</span>
                          </div>
                        </div>
                      </li>
                      <li class="list-group-item d-flex justify-content-between">
                        <div class="avatar-list avatar-list-stacked">
                          <span>Sponsor by:</span>
                          <img class="avatar xs rounded" src="../assets/images/xs/avatar8.jpg" data-bs-toggle="tooltip"
                            data-placement="top" title="" data-original-title="Sean">
                          <img class="avatar xs rounded ml-1" src="../assets/images/xs/avatar7.jpg"
                            data-bs-toggle="tooltip" data-placement="top" title="" data-original-title="Martin">
                        </div>
                        <div class="text-danger">
                          <strong>$101</strong>
                        </div>
                      </li>
                    </ul>
                    <div class="card-body">
                      <div class="d-flex align-items-center">
                        <img src="../assets/images/xs/avatar3.jpg" data-bs-toggle="tooltip" title="" alt="Avatar"
                          class="rounded-circle avatar" data-original-title="Avatar Name">
                        <div class="ms-3 flex-grow-1">
                          <a href="javascript:void(0)" title="">By Daniel Kristeen</a>
                          <p class="mb-0">35 min ago</p>
                        </div>
                        <div class="dropdown" dropdown placement="bottom right">
                          <a href="javascript:void(0)" class="btn btn-link btn-sm dropdown-toggle" id="button-alignment"
                            dropdownToggle type="button" aria-controls="dropdown-alignment">
                            <i class="zmdi zmdi-more-vert zmdi-hc-lg"></i>
                          </a>
                          <div id="dropdown-alignment" *dropdownMenu class="dropdown-menu dropdown-menu-right"
                            role="menu" aria-labelledby="button-alignment">
                            <a href="javascript:void(0)" class="dropdown-item">Action</a>
                            <a href="javascript:void(0)" class="dropdown-item">Another action</a>
                            <a href="javascript:void(0)" class="dropdown-item">Something else here</a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div> <!-- .row end -->
            </div>
            <div class="col-xl-3 col-lg-4 col-md-12">
              <div class="border-start p-4">
                <div class="mb-5">
                  <h6 class="card-title">Top Sponsors</h6>
                  <div class="avatar-list avatar-list-stacked">
                    <img class="avatar sm rounded ml-1" src="../assets/images/xs/avatar5.jpg" data-bs-toggle="tooltip"
                      title="" data-original-title="Avatar">
                    <img class="avatar sm rounded ml-1" src="../assets/images/xs/avatar6.jpg" data-bs-toggle="tooltip"
                      title="" data-original-title="Avatar">
                    <img class="avatar sm rounded ml-1" src="../assets/images/xs/avatar1.jpg" data-bs-toggle="tooltip"
                      title="" data-original-title="Avatar">
                    <img class="avatar sm rounded ml-1" src="../assets/images/xs/avatar4.jpg" data-bs-toggle="tooltip"
                      title="" data-original-title="Avatar">
                  </div>
                </div>
                <div class="mb-5">
                  <h6 class="card-title">Categories</h6>
                  <ul class="list-unstyled ul-list row">
                    <li class="col-lg-12 col-md-4 col-sm-6"><a href="javascript:void(0)"><i
                          class="zmdi zmdi-caret-right me-2"></i>All
                        Categories</a></li>
                    <li class="col-lg-12 col-md-4 col-sm-6"><a href="javascript:void(0)"><i
                          class="zmdi zmdi-caret-right me-2"></i>Art</a>
                    </li>
                    <li class="col-lg-12 col-md-4 col-sm-6"><a href="javascript:void(0)"><i
                          class="zmdi zmdi-caret-right me-2"></i>Books</a></li>
                    <li class="col-lg-12 col-md-4 col-sm-6"><a href="javascript:void(0)"><i
                          class="zmdi zmdi-caret-right me-2"></i>Food</a>
                    </li>
                    <li class="col-lg-12 col-md-4 col-sm-6"><a href="javascript:void(0)"><i
                          class="zmdi zmdi-caret-right me-2"></i>Sports</a></li>
                    <li class="col-lg-12 col-md-4 col-sm-6"><a href="javascript:void(0)"><i
                          class="zmdi zmdi-caret-right me-2"></i>Films</a></li>
                    <li class="col-lg-12 col-md-4 col-sm-6"><a href="javascript:void(0)"><i
                          class="zmdi zmdi-caret-right me-2"></i>Awards</a></li>
                    <li class="col-lg-12 col-md-4 col-sm-6"><a href="javascript:void(0)"><i
                          class="zmdi zmdi-caret-right me-2"></i>Men</a>
                    </li>
                    <li class="col-lg-12 col-md-4 col-sm-6"><a href="javascript:void(0)"><i
                          class="zmdi zmdi-caret-right me-2"></i>Parties</a></li>
                    <li class="col-lg-12 col-md-4 col-sm-6"><a href="javascript:void(0)"><i
                          class="zmdi zmdi-caret-right me-2"></i>Technology</a></li>
                    <li class="col-lg-12 col-md-4 col-sm-6"><a href="javascript:void(0)"><i
                          class="zmdi zmdi-caret-right me-2"></i>Science</a></li>
                    <li class="col-lg-12 col-md-4 col-sm-6"><a href="javascript:void(0)"><i
                          class="zmdi zmdi-caret-right me-2"></i>Women</a></li>
                    <li class="col-lg-12 col-md-4 col-sm-6"><a href="javascript:void(0)"><i
                          class="zmdi zmdi-caret-right me-2"></i>Music</a></li>
                    <li class="col-lg-12 col-md-4 col-sm-6"><a href="javascript:void(0)"><i
                          class="zmdi zmdi-caret-right me-2"></i>Comendy</a></li>
                    <li class="col-lg-12 col-md-4 col-sm-6"><a href="javascript:void(0)"><i
                          class="zmdi zmdi-caret-right me-2"></i>Show</a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
      <!-- End Page Default -->

    </div>
    <!-- End chat body -->

  </div>
  <!-- Main Body: Content -->
</div>
